module.exports = __webpack_public_path__ + "img/footer-bg2.aecefaaf.jpg";